goog.provide('el8.ptdata.clinicalForms');

goog.require('el8.model.base');
goog.require('el8.util.base');


el8.ptdata.clinicalForms = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);

        // FUTURE: make a model for questions if needed and set to the model
        // instead of raw object, if necessary
        if (spec.questions) {
          this.setQuestions(spec.questions);
        }
        if (spec.total_score_question) {
          this.setTotalScoreQuestion(spec.total_score_question);
        }
    };

    _class.addStringProperty('category');
    _class.addStringProperty('name');
    _class.addStringProperty('label');
    _class.addStringProperty('informationUrl');
    _class.addProperty('questions');
    _class.addProperty('totalScoreQuestion');

    /**
     * Returns the history type (history type as understood by the visit note)
     * for this form - this is based on the form's category.
     *
     * NOTE: this might be a logical duplicate of el8.appchart.visitNote.util.getReferenceInfo
     * for PatientHistoryItems, at least right now. In the future if we expand
     * clinical forms that may no longer be the case.
     */
    _class.prototype.getHistoryType = function getHistoryType() {
      switch (this.getCategory()) {
        case 'Social':
          return 'social';
        case 'Psychological':
          return 'psychological';
        case 'Habits':
          return 'habits';
        case 'Exercise':
          return 'exercise';
        default:
          return null;
      }
    }

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); }
    });

    return that;
})();
